// §5 section label — Hanken 700 11px, tracked .16em, uppercase, --meta.
// The section-anatomy header used above every list on cream, and the
// left column of a `SectionRow` (label + inline link).

import type { ReactNode } from "react";
import { TextLink } from "./CTA";

export function SectionLabel({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <p
      className={`text-[11px] font-bold uppercase leading-none tracking-[0.16em] text-meta ${className}`}
    >
      {children}
    </p>
  );
}

export function SectionRow({
  label,
  action,
  onAction,
  className = "",
}: {
  label: ReactNode;
  action?: string;
  onAction?: () => void;
  className?: string;
}) {
  return (
    <div className={`mx-5 mt-6 mb-2.5 flex items-baseline ${className}`}>
      <SectionLabel>{label}</SectionLabel>
      {action && (
        <TextLink className="ml-auto" onClick={onAction}>
          {action}
        </TextLink>
      )}
    </div>
  );
}
